import Template2Cols from './Template2Cols';

export default Template2Cols;
